import React, { useState } from "react";
import styled from "styled-components";
import FaqsCard from "./FaqsCard";
import colors from "../../constatns/colors";
import useWindowDimensions from "../../constatns/size";

import "../../styles/home.css";

function FaqsQuestions({ 
    firstQuestion, firstDescription,
    secondQuestion, secondDescription,
    thirdQuestion, thirdDescription,
    fourthQuestion, fourthDescription,
    fifthQuestion, fifthDescription

}) {
    const { width, height } = useWindowDimensions();
    const [question1, setQuestion1] = useState(false);
    const [question2, setQuestion2] = useState(false);
    const [question3, setQuestion3] = useState(false);
    const [question4, setQuestion4] = useState(false);
    const [question5, setQuestion5] = useState(false);
  return (
    <Container width={width} height={height} >
        <InnerContainer style={{flexDirection: "column"}}>
            <FaqsCard
                title={firstQuestion}
                isDescription={question1}
                onClick={()=> setQuestion1(!question1)}
                description={firstDescription}
            />
            <FaqsCard
                title={secondQuestion}
                onClick={()=> setQuestion2(!question2)}
                isDescription={question2}
                description={secondDescription}
            />
            { thirdQuestion &&
                <FaqsCard
                    title={thirdQuestion}
                    onClick={()=> setQuestion3(!question3)}
                    isDescription={question3}
                    description={thirdDescription}
                />
            }
            { fourthQuestion &&
                <FaqsCard
                    title={fourthQuestion}
                    onClick={()=> setQuestion4(!question4)}
                    isDescription={question4}
                    description={fourthDescription}
                />
            }
            { fifthQuestion &&
                <FaqsCard
                    title={fifthQuestion}
                    onClick={()=> setQuestion5(!question5)}
                    isDescription={question5}
                    description={fifthDescription}
                />
            }
        </InnerContainer>
    </Container>
  );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px ;

    @media (max-width: 768px) {
    margin-top: 0px ;
        
    }
`

const InnerContainer = styled.div`
    display: flex;
    margin-top: ${({height})=> height * 0.05}px ;
    color: ${colors.white};
    justify-content: center;

`

const Btn = styled.button`
    border: 0px;
    background-color: ${({color})=> color};
    color: ${colors.white};
    padding: 10px 30px;
    margin-left: 30px;
    border-radius: 5px;
`

export default FaqsQuestions;
